import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isNil, isEmpty } from 'lodash';

export class EigValidators {
    static json(control: AbstractControl): ValidationErrors | null {
        let valid = true;

        if (!isNil(control.value) && !isEmpty(control.value)) {
            try {
                JSON.parse(control.value);
            } catch (err) {
                valid = false;
            }
        }

        return valid ? null : { 'json': true };
    }
}
